import { compose } from 'recompose';
import { connect } from 'react-redux';
import StageTime from './component';

import { getTimeDone } from 'redux/modules/journeys/stop-status-log';
import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const stopFields = ['stop_type', 'status', 'shipment_state_logs', 'time_from'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { stage, selectors, journeyId, stopId } = props;

    const { shipment_state_logs, stop_type, time_from } =
      selectors.getJourneyStopFields(state, journeyId, stopId, stopFields) || {};

    const time = getTimeDone(stage, { shipment_state_logs, stop_type });
    return {
      time,
      stopType: stop_type,
      stopTimeFrom: time_from,
    };
  })
);

export default enhance(StageTime);
